import {reactive} from 'vue';
import {_loadContexts, _saveContexts} from '@/service/userdata-service';
import {getCookie} from "@/utils/cookies";
import {getBillingPeriod} from "@/service/meta-service";

export const mainState = reactive({
    isSavePopupVisible: false,
    routePath: null,
    isReload: null,
    isWidgetOpening: false,
    viewId: null,
});
export let shownNavigator = undefined;

export function setSaveUserDataPopupVisible(visible) {
    mainState.isSavePopupVisible = visible;
}

export function setChangeRouteFunc(route) {
    mainState.routePath = route;
}

export function setIsReloadValue(value) {
    mainState.isReload = value;
}

export function setIsWidgetOpening(value) {
    mainState.isWidgetOpening = value;
}

export class ContextNames {
    static get ORG_CONTEXT_GROUP() {
        return 'ORG_CONTEXT_GROUP';
    }
}

let contextGroups = {};
const contextBase = {
    value: null,
    userText: '',
};
let displayedNavigator = undefined;
const defValueGroups = {
    ORG_CONTEXT_GROUP: {
        groupName: ContextNames.ORG_CONTEXT_GROUP,
        contexts: {
            PayerContext: {},
            DogContext: {},
            NumObjContext: {},
            PointContext: {},
        },
    },
};
export const getDefaultContextGroup = (name) => {
    const contextGroup = {
        groupName: ContextNames[name],
        contexts: {...defValueGroups[ContextNames[name]].contexts},
    };
    for (const key of Object.keys(contextGroup.contexts)) {
        Object.assign(contextGroup.contexts[key], contextBase);
    }
    return JSON.parse(JSON.stringify(contextGroup));
};
export const initContextGroups = async () => {
    const contextGroupsResult = await _loadContexts({});
    if (contextGroupsResult.result && contextGroupsResult.success) {
        contextGroups = contextGroupsResult.changes;
    } else {
        //TODO тут надо уже знать контекстную группу, сейчас она захардкожена
        const contextName = ContextNames.ORG_CONTEXT_GROUP
        contextGroups[contextName] = getDefaultContextGroup(contextName);
    }
    await refreshNavigatorData();
};
export const initDisplayedNavigator = async (ref) => displayedNavigator = ref;
const refreshNavigatorData = async () => {
    if (displayedNavigator?.refreshData === undefined) {
        throw new Error(`Не задан instance навигатора`);
    }
    await displayedNavigator.refreshData();
}
export const saveContexts = async args => {
    if (args === undefined) {
        throw new Error(`Значение аргумента функции установки контекста: args === undefined`);
    }
    if (args.value === undefined) {
        throw new Error(`Значение аргумента функции установки контекста: args.value === undefined `);
    }
    if (args.value.contexts === undefined) {
        throw new Error(`Значение аргумента функции установки контекста: args.value.contexts === undefined `);
    }
    let validGroups = Object.keys(Object.getOwnPropertyDescriptors(ContextNames));
    validGroups = validGroups.filter(item => item !== 'name');
    validGroups = validGroups.filter(item => item !== 'length');
    validGroups = validGroups.filter(item => item !== 'prototype');
    if (validGroups.includes(args.nameGroup)) {
        const validContexts = Object.keys(defValueGroups[args.nameGroup].contexts);
        for (const key of Object.keys(args.value.contexts)) {
            if (!validContexts.includes(key)) {
                throw new Error(`Указано имя контекста: ${key} не допустимое в группе: ${args.nameGroup}`);
            }
            const contextValues = Object.keys(contextBase);
            for (const contextField of Object.keys(args.value.contexts[key])) {
                if (!contextValues.includes(contextField)) {
                    throw new Error(`Указано имя поля: ${contextField} не допустимое в контексте: ${key}`);
                }
            }
        }
        const saveContextsResult = await _saveContexts(args);
        contextGroups = saveContextsResult.changes;
        await refreshNavigatorData();
        return saveContextsResult;
    } else {
        throw new Error(`Получено несуществующее имя группы контекстов: ${args.nameGroup}`);
    }
};

export function getContextGroup(name) {
    if (ContextNames[name] === undefined) {
        throw new Error(`Получено неизвестное имя контекста: ${name}`);
    }
    const contextGroup = contextGroups[name];
    return JSON.parse(JSON.stringify(contextGroup));
}

export function setViewId(value) {
    mainState.viewId = value;
}

export const layoutState = {
    state: 'default',
};

export const activeViewInfo = {
    activeViewInstance: null,
    routeName: null,
};

export function setLayoutState(state) {
    layoutState.state = state;
}

export function setActiveViewInfo(inst, route) {
    activeViewInfo.activeViewInstance = inst;
    activeViewInfo.routeName = route;
}

export async function setViewData() {
    await activeViewInfo.activeViewInstance?.refresh();
    await activeViewInfo.activeViewInstance?.userData();
    await activeViewInfo.activeViewInstance?.userSettings();
}

let globYm = null;
export const getGlobYm = async () => {
    if (!globYm) {
        const dep = getCookie('dep');
        globYm = await getBillingPeriod({n_podr: dep});
    }
    return globYm;
}
